import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { CrisisScenarioManager } from '../components/crisis/CrisisScenarioManager';
import { useSubscriptionAccess } from '../hooks/useSubscriptionAccess';
import { SubscriptionRequired } from '../components/SubscriptionRequired';

export function StressTestPage() {
  const navigate = useNavigate();
  const { hasActiveSubscription } = useSubscriptionAccess();

  if (!hasActiveSubscription) {
    return (
      <SubscriptionRequired
        feature="Tests de crise"
        description="Créez des scénarios de crash test pour anticiper les crises et mesurer leur impact sur votre trésorerie."
        requiredPlan="Abonnement actif requis"
      />
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <button
          onClick={() => navigate('/dashboard')}
          className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 mb-6"
        >
          <ArrowLeft className="h-5 w-5" />
          <span>Retour au tableau de bord</span>
        </button>

        <CrisisScenarioManager />
      </div>
    </div>
  );
}
